import React from 'react';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import * as actions from "../../Projects/_redux/projectsActions";
import {generateCSVFileFromArray} from "../utils/excel";
import {headersProjects} from "../constants/exportedFilesHeaders";
import can from "../components/Permissions/can";

export function ExportCustomersForProjectColumnFormatter(cellContent, dispatch) {

  const exportProjectsFileFunc = (id) => {
    dispatch(actions.exportProjectsFile(id))
      .then((data) => [headersProjects, ...data])
      .then((data) => generateCSVFileFromArray(data, "Projects.csv"))
      .catch((error) => {
        console.error(`Error: + ${error}`);
      })
  };

  const disabledCondition = !can('full', 'projectsPage');

  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
  ${disabledCondition ? `custom-disabled-button cursor-default` : ``}`;

  return (
    <Button
      className={buttonClassName}
      onClick={() => exportProjectsFileFunc(cellContent)}
      disabled={disabledCondition}
    >
      <img
        src={toAbsoluteUrl("/media/svg/Excel_brandColor.svg")}
        alt="icon"
      />
    </Button>
  )
}